import "../styles/card.css";
import "../styles/card.css";
import cloudIcon from "./cloud.jpg";


// React Imports :

import { useEffect, useMemo, useReducer, useState } from "react";

// API calls :

import { fetchData } from "../API/fetchData";

// external libraries :

import { useTranslation } from "react-i18next";

import moment from "moment";
import "moment/min/locales";

// use Reducer :

import changeDrtReducer from "../reducers/changeDrtReducer";

export default function Card() {

    const { t, i18n } = useTranslation();

    const [statue, setStatue] = useState({
        temp: null,
        tempMax: null,
        tempMin: null,
        desc: "",
        icon: "",
        name: "",
    });

    const [date, setDate] = useState("");

    const [btnPst, dispatch] = useReducer(changeDrtReducer, {
        lan: "rtl",
        language: "arabic",
        nexLan: "en",
        date : "",
    })


    const apiKey = "871fd7e17c1b2bac98be3a3b3c76fa00";
    const lat = 33.1228;
    const lon = -7.62194;

    useMemo(() => {
        setDate(moment().format("MMMM Do YYYY"));
    }, []);

    useEffect(() => {
        i18n.changeLanguage(btnPst.nexLan);
    }, [btnPst.nexLan]);

    useEffect(() => {
        let isIgnored = false;

        const url = ` https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}`;

        async function fetchDataLocally(url) {
            const { temp, tempMax, tempMin, name, desc, icon } = await fetchData(url);

            if (!isIgnored)
                setStatue({
                    temp,
                    tempMax,
                    tempMin,
                    name: name.split(" ")[0],
                    desc,
                    icon,
                });
        }

        fetchDataLocally(url);

        return () => {
            isIgnored = true;
        };
    }, []);

    function handleToggleLanguage() {
        dispatch({type : "toggled"})
        moment.locale(btnPst.nexLan === "ar" ? "en" : "ar");
        setDate(moment().format("MMMM Do YYYY"));
    }

    return (
        <>
            <div
                className="card"
                style={{ direction: btnPst.lan === "ltr" ? "rtl" : "ltr" }}
            >
                <div className="header">
                    <h2 className="city"> {t(statue.name)} </h2>
                    <p className="time"> {date} </p>
                </div>
                <hr style={{ marginTop: "20px" }} />
                <div className="content">
                    <div className="desc">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div>
                                <p className="degree">{statue.temp}</p>
                                <p className="statue">{t(statue.desc)}</p>
                            </div>
                            <img
                                src={`https://openweathermap.org/img/wn/${statue.icon}@2x.png`}
                                alt="small cloud"
                                className="small-icon"
                                style={{ marginTop: "-30px" }}
                            />
                        </div>
                        <div className="degree-desc">
                            <p className="min">
                                {t("min")}: {statue.tempMax}
                            </p>
                                <span style={{display : "inline-block", marginRight : "7px"}}>|</span>
                            <p className="max">
                                {t("max")} : {statue.tempMin}
                            </p>
                        </div>
                    </div>
                    <img
                        src={cloudIcon}
                        alt="cloud"
                        className="main-icon"
                        style={{ borderRadius: "10px", width: "100px " }}
                    />
                </div>
            </div>
            <div style={{ direction: btnPst.lan }}>
                <button
                    className="toggleLan"
                    onClick={handleToggleLanguage}
                >
                    {btnPst.language}
                </button>
            </div>
        </>
    );
}